// Toppings data
const toppings = [
  {
    id: 1,
    name: 'Lettuce',
    price: 0.00,
    is_premium: false
  },
  {
    id: 2,
    name: 'Tomato',
    price: 1.50,
    is_premium: true
  },
  {
    id: 3,
    name: 'Coleslaw',
    price: 1.50,
    is_premium: true
  },
  {
    id: 4,
    name: 'Sauerkraut',
    price: 1.50,
    is_premium: true
  },
  {
    id: 5,
    name: 'Onion',
    price: 0.00,
    is_premium: false
  },
  {
    id: 6,
    name: 'Grilled Onion',
    price: 0.50,
    is_premium: false
  },
  {
    id: 7,
    name: 'Cucumber',
    price: 0.50,
    is_premium: false
  },
  {
    id: 8,
    name: 'Bell Pepper',
    price: 0.50,
    is_premium: false
  },
  {
    id: 9,
    name: 'Mild Peppers',
    price: 2.00,
    is_premium: true
  },
  {
    id: 10,
    name: 'Fried Egg',
    price: 2.00,
    is_premium: true
  },
  {
    id: 11,
    name: 'Sweet Relish',
    price: 1.00,
    is_premium: false
  },
  {
    id: 12,
    name: 'Capers',
    price: 1.00,
    is_premium: false
  },
  {
    id: 13,
    name: 'Bacon',
    price: 2.50,
    is_premium: true
  },
  {
    id: 14,
    name: 'Extra Meat',
    price: 1.95,
    is_premium: true
  },
  {
    id: 15,
    name: 'Butter',
    price: 1.00,
    is_premium: false
  },
  {
    id: 16,
    name: 'Cream Cheese',
    price: 1.50,
    is_premium: true
  },
  {
    id: 17,
    name: 'Pickles',
    price: 1.50,
    is_premium: true
  }
];

export default toppings;